/**
 * REMOVABLE DEMO: single source of truth for the BYO-DB / AdminDemo
 * localStorage blob. All demo readers/writers (adminDemoFields,
 * adminDemoSelections, AdminDemo/storage) go through here so the schema
 * version is enforced consistently. Delete with the demo.
 *
 * Every write stamps the current schema version. On read, a missing or
 * older version means the persisted data predates a demo change (e.g. a
 * provider rename), so we drop it and let callers re-seed from current
 * code. Bump ADMIN_DEMO_SCHEMA_VERSION whenever stored demo data should be
 * discarded.
 */
export const ADMIN_DEMO_STORAGE_KEY = "sb_admin_demo";

export const ADMIN_DEMO_SCHEMA_VERSION = 1;

const VERSION_FIELD = "__schemaVersion";

export function readAdminDemoStore(): Record<string, unknown> {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(ADMIN_DEMO_STORAGE_KEY);
    if (raw == null) return {};
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    if (parsed[VERSION_FIELD] !== ADMIN_DEMO_SCHEMA_VERSION) {
      window.localStorage.removeItem(ADMIN_DEMO_STORAGE_KEY);
      return {};
    }
    const { [VERSION_FIELD]: _version, ...fields } = parsed;
    return fields;
  } catch {
    return {};
  }
}

export function writeAdminDemoStore(fields: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      ADMIN_DEMO_STORAGE_KEY,
      JSON.stringify({ ...fields, [VERSION_FIELD]: ADMIN_DEMO_SCHEMA_VERSION }),
    );
  } catch {
    // best-effort
  }
}
